/*@flow*/
import naturalCmp from 'underscore.string/naturalCmp';

export default (v1: string, v2: string): any =>
  naturalCmp(v1.toLowerCase(), v2.toLowerCase());
